import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=8f0f3c70&scoped=true"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"
import style0 from "./Percentage.vue?vue&type=style&index=0&id=8f0f3c70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0f3c70",
  null
  
)

export default component.exports